"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackClickMoreDetailsForExperience = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
const trackClickMoreDetailsForExperience = (clickText, clickElement) => {
    const bookingEvent = {
        event: 'JS_Event',
        eventData: {
            eventName: enums_1.GA4EventName.ClickButton,
            feature_category: enums_1.GA4FeatureCategory.ProviderList,
            click_text: clickText,
            click_element: clickElement,
        },
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)(bookingEvent);
};
exports.trackClickMoreDetailsForExperience = trackClickMoreDetailsForExperience;
//# sourceMappingURL=trackClickMoreDetailsForExperience.js.map